// 30SDP homepage sections: video player dialog and product card variant prices.
// Free shipping line in the visitor's currency. The US store is USD only; the
// Global store (window.sdpStore.intl, set in layout/theme.liquid) shows prices
// in each country's currency, and Shopify converts the $45 line at checkout at
// Shopify.currency.rate. Rounded up to a whole unit so "free shipping" is
// never promised below the real line.
window.sdpLocalCents = function (cents) {
  var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  return rate === 1 ? cents : Math.ceil(cents * rate / 100) * 100;
};

(function () {
  function youtubeId(url) {
    var m = String(url || '').match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/)([\w-]{11})/);
    return m ? m[1] : null;
  }

  var player;
  function openPlayer(url, portrait) {
    var id = youtubeId(url);
    if (!id || typeof HTMLDialogElement !== 'function') {
      window.open(url, '_blank', 'noopener');
      return;
    }
    if (!player) {
      player = document.createElement('dialog');
      player.className = 'sdp-player';
      player.innerHTML =
        '<button type="button" class="sdp-player__close" aria-label="Close video">&times;</button>' +
        '<div class="sdp-player__frame"></div>';
      document.body.appendChild(player);
      player.querySelector('.sdp-player__close').addEventListener('click', function () { player.close(); });
      player.addEventListener('click', function (e) { if (e.target === player) player.close(); });
      player.addEventListener('close', function () { player.querySelector('.sdp-player__frame').innerHTML = ''; });
    }
    player.classList.toggle('sdp-player--portrait', !!portrait);
    player.querySelector('.sdp-player__frame').innerHTML =
      '<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0" ' +
      'allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen title="Video"></iframe>';
    player.showModal();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sdp-video]');
    if (!trigger) return;
    e.preventDefault();
    openPlayer(trigger.getAttribute('data-sdp-video'), trigger.hasAttribute('data-sdp-video-portrait'));
  });

  // Music player: the button slides up from the bottom of the window. Each
  // press plays a 10-second preview of the next song, bobbing while it
  // plays; nothing plays on its own. Opened by any [data-sdp-music] element,
  // whose value is JSON from snippets/sdp-music-data.liquid.
  var PREVIEW_SECONDS = 10;
  var music;
  function musicPlayer() {
    if (music) return music;
    var el = document.createElement('div');
    el.className = 'sdp-jukebox';
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Song previews');
    el.innerHTML =
      '<button type="button" class="sdp-jukebox__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>' +
      '<p class="sdp-jukebox__caption">Push again to hear the next song</p>' +
      '<button type="button" class="sdp-jukebox__button"><img alt=""></button>';
    document.body.appendChild(el);
    var audio = new Audio();
    audio.preload = 'auto';
    var button = el.querySelector('.sdp-jukebox__button');
    var stopTimer;
    music = { index: -1, list: null };

    function stop() {
      clearTimeout(stopTimer);
      audio.pause();
      el.classList.remove('is-playing');
      document.documentElement.classList.remove('sdp-music-on');
    }
    music.next = function () {
      var tracks = music.list.tracks;
      music.index = (music.index + 1) % tracks.length;
      var track = tracks[music.index];
      clearTimeout(stopTimer);
      audio.src = track.url;
      audio.currentTime = 0;
      audio.play().catch(function () {});
      button.setAttribute('aria-label', 'Playing ' + track.title + '. Press for the next song.');
      el.classList.remove('is-pressed');
      void el.offsetWidth;
      el.classList.add('is-pressed');
    };
    audio.addEventListener('playing', function () {
      el.classList.add('is-playing');
      document.documentElement.classList.add('sdp-music-on');
      clearTimeout(stopTimer);
      stopTimer = setTimeout(stop, PREVIEW_SECONDS * 1000);
    });
    audio.addEventListener('ended', stop);
    music.open = function (list) {
      if (music.list !== list) music.index = -1;
      music.list = list;
      var img = button.querySelector('img');
      if (list.image) img.src = list.image;
      el.classList.add('is-open');
      music.next();
    };
    button.addEventListener('click', function () { music.next(); });
    el.querySelector('.sdp-jukebox__close').addEventListener('click', function () {
      stop();
      el.classList.remove('is-open');
    });
    return music;
  }
  var musicLists = new WeakMap();
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sdp-music]');
    if (!trigger) return;
    e.preventDefault();
    var list = musicLists.get(trigger);
    if (!list) {
      try { list = JSON.parse(trigger.getAttribute('data-sdp-music')); } catch (err) { return; }
      musicLists.set(trigger, list);
    }
    if (list && list.tracks && list.tracks.length) musicPlayer().open(list);
  });

  // Product tabs: show the clicked tab's panel.
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.sdp-tabs__tab');
    if (!tab) return;
    var root = tab.closest('[data-sdp-tabs]');
    root.querySelectorAll('.sdp-tabs__tab').forEach(function (t) {
      var selected = t === tab;
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  });

  // Pack family cards: show the pointed-at pack's photo.
  function showPack(button) {
    var card = button.closest('[data-sdp-card]');
    var img = card && card.querySelector('.sdp-card__image img');
    if (!img) return;
    if (!img.dataset.sdpOriginal) img.dataset.sdpOriginal = img.currentSrc || img.src;
    img.removeAttribute('srcset');
    img.src = button.getAttribute('data-sdp-pack-image') || img.dataset.sdpOriginal;
    var zoom = button.closest('[data-card-zoom]');
    if (zoom) img.parentElement.style.setProperty('--sdp-card-zoom', zoom.getAttribute('data-card-zoom'));
  }
  ['mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var row = e.target.closest && e.target.closest('.sdp-packs__row');
      var button = row && row.querySelector('[data-sdp-pack-image]');
      if (button) showPack(button);
    });
  });

  // Bundle builder: pick how many buttons, then which (repeats allowed) and
  // optional Party Lights. Adds the singles and lights to the cart as
  // separate lines labelled as one bundle; the bundle discount itself is an
  // automatic discount in Shopify, mirrored here by the section's tiers.
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount\w*\s*\}\}/, amount);
  }
  function initBuilder(root) {
    var data = JSON.parse(root.querySelector('[data-sdp-builder-data]').textContent);
    var sizes = [].slice.call(root.querySelectorAll('[data-size]'));
    var picks = [].slice.call(root.querySelectorAll('[data-pick]'));
    var tray = root.querySelector('[data-sdp-builder-tray]');
    var prompt = root.querySelector('[data-sdp-builder-prompt]');
    var priceEl = root.querySelector('[data-sdp-builder-price]');
    var wasEl = root.querySelector('[data-sdp-builder-was]');
    var saveEl = root.querySelector('[data-sdp-builder-save]');
    var add = root.querySelector('[data-sdp-builder-add]');
    var shipEl = root.querySelector('[data-sdp-builder-ship]');
    var bars = [].slice.call(root.querySelectorAll('.sdp-builder__bar'));
    var controls = root.querySelector('.sdp-builder__controls');
    var doneTitle = root.querySelector('[data-sdp-builder-done-title]');
    var editBtn = root.querySelector('[data-sdp-builder-edit]');
    var resetBtn = root.querySelector('[data-sdp-builder-reset]');
    // Fold the steps away once the last button is picked, so Add to cart is
    // easy to find; Edit unfolds them. Removing a pick unfolds them too.
    function setDone(done, scroll) {
      if (!controls) return;
      controls.classList.toggle('is-done', done);
      if (editBtn) editBtn.setAttribute('aria-expanded', done ? 'false' : 'true');
      if (done && doneTitle) doneTitle.textContent = 'Your bundle of ' + state.size + ' is ready';
      if (done && scroll) {
        setTimeout(function () {
          var r = add.getBoundingClientRect();
          if (r.top < 80 || r.bottom > window.innerHeight - 20) {
            window.scrollTo({ top: window.scrollY + r.top - window.innerHeight / 2 + r.height / 2, behavior: 'smooth' });
          }
          add.classList.remove('is-ready-pulse');
          void add.offsetWidth;
          add.classList.add('is-ready-pulse');
        }, 420);
      }
    }
    if (editBtn) editBtn.addEventListener('click', function () { setDone(false); });
    // Reset: clear the picks and go back to "How many buttons?".
    if (resetBtn) resetBtn.addEventListener('click', function () {
      state.size = 0;
      state.order = [];
      setDone(false);
      render();
      var layoutEl = root.querySelector('[data-sdp-builder-layout]');
      if (layoutEl) layoutEl.classList.add('is-intro');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    // state.order: tile keys (variant IDs) in pick order.
    var state = { size: 0, order: [] };

    var byKey = {};
    picks.forEach(function (el) { byKey[el.dataset.key] = el; });
    function qty(key) { return state.order.filter(function (x) { return x === key; }).length; }
    function matchingPack() {
      var ids = state.order.map(function (key) { return byKey[key].dataset.variant; }).sort().join(',');
      var p = (data.packs || {})[ids];
      return p && p.available ? p : null;
    }
    function tier() {
      var best = null;
      (data.tiers || []).forEach(function (t) { if (state.size >= t.qty && (!best || t.qty >= best.qty)) best = t; });
      return best;
    }

    function render() {
      var left = state.size - state.order.length;
      if (resetBtn) resetBtn.hidden = !state.size;
      if (left > 0 && controls && controls.classList.contains('is-done')) setDone(false);
      sizes.forEach(function (b) { b.setAttribute('aria-checked', Number(b.dataset.size) === state.size ? 'true' : 'false'); });
      picks.forEach(function (el) {
        var n = qty(el.dataset.key);
        var soldOut = el.hasAttribute('data-sold-out');
        el.classList.toggle('is-picked', n > 0);
        el.querySelector('[data-pick-count]').textContent = n ? '×' + n : '';
        el.querySelector('[data-pick-add]').disabled = soldOut || (state.size > 0 && left <= 0);
        el.querySelector('[data-pick-minus]').disabled = n === 0;
      });

      // The tray: a slot per button, filled in pick order, each with a
      // Remove bar beneath it.
      var html = '';
      for (var i = 0; i < state.size; i++) {
        var key = state.order[i];
        if (key) {
          var el = byKey[key];
          html += '<span class="sdp-builder__slot-wrap">' +
            '<button type="button" class="sdp-builder__slot is-filled' + (el.classList.contains('sdp-builder__pick--light') ? ' is-light' : '') + '" data-slot="' + i + '" aria-label="Remove ' + el.dataset.name + '"><img src="' + el.dataset.image + '" alt=""><span class="sdp-builder__slot-minus" aria-hidden="true"></span></button>' +
            '</span>';
        } else {
          html += '<span class="sdp-builder__slot-wrap"><span class="sdp-builder__slot" aria-hidden="true"></span></span>';
        }
      }
      tray.innerHTML = html;

      var buttons = 0;
      state.order.forEach(function (key) { buttons += Number(byKey[key].dataset.price); });
      var t = left === 0 ? tier() : null;
      var off = t ? Math.round(buttons * t.pct / 100) : 0;
      // A full bundle that matches a pack we sell gets the pack's price.
      var pack = left === 0 ? matchingPack() : null;
      if (pack) off = buttons - pack.price;
      var freeShip = data.freeShipQty > 0 && state.size >= data.freeShipQty;
      var shipNote = '';
      if (shipEl) shipEl.hidden = !freeShip;
      bars.forEach(function (bar) {
        bar.classList.toggle('is-active', state.size >= Number(bar.dataset.from) && state.size <= Number(bar.dataset.to));
      });
      var total = buttons - off;
      if (state.order.length) {
        priceEl.textContent = formatMoney(total, data.money);
        wasEl.textContent = off ? formatMoney(buttons, data.money) : '';
        saveEl.textContent = pack
          ? (off > 0 ? 'Pack price \u2014 saves ' + formatMoney(off, data.money) : 'Pack price') + shipNote
          : off
          ? 'Bundle saves ' + formatMoney(off, data.money) + ' (' + t.pct + '% off)' + shipNote
          : (left > 0 && tier() ? 'Fill it up to save ' + tier().pct + '%' + shipNote : '');
      } else {
        priceEl.textContent = '';
        wasEl.textContent = '';
        saveEl.textContent = '';
      }
      prompt.textContent = left > 0 ? (state.order.length ? 'Pick ' + left + ' more' : 'Pick ' + state.size + ' buttons') + ' — multiples welcome' : 'Your bundle is ready';
      add.disabled = left !== 0;
      add.textContent = left === 0 ? data.addLabel + ' — ' + formatMoney(total, data.money) : 'Pick ' + left + ' more';
      if (!state.size) {
        prompt.textContent = 'Pick your buttons';
        add.disabled = true;
        add.textContent = 'Choose how many buttons';
      }
    }

    var layout = root.querySelector('[data-sdp-builder-layout]');
    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        // First pick: open from the size-only intro into the full builder.
        if (layout && layout.classList.contains('is-intro')) {
          layout.classList.remove('is-intro');
          layout.classList.add('is-opening');
          setTimeout(function () { layout.classList.remove('is-opening'); }, 900);
        }
        state.size = Number(b.dataset.size);
        state.order = state.order.slice(0, state.size);
        render();
      });
    });
    picks.forEach(function (el) {
      var key = el.dataset.key;
      el.querySelector('[data-pick-add]').addEventListener('click', function () {
        if (!state.size) {
          // Point them at step 1 first.
          var row = root.querySelector('.sdp-builder__sizes');
          row.classList.remove('is-nudging');
          void row.offsetWidth;
          row.classList.add('is-nudging');
          return;
        }
        if (state.order.length >= state.size) return;
        state.order.push(key);
        el.classList.remove('is-popping');
        void el.offsetWidth;
        el.classList.add('is-popping');
        render();
        if (state.order.length === state.size) setTimeout(function () { setDone(true, true); }, 350);
      });
      el.querySelector('[data-pick-minus]').addEventListener('click', function () {
        var i = state.order.lastIndexOf(key);
        if (i !== -1) state.order.splice(i, 1);
        render();
      });
    });
    tray.addEventListener('click', function (e) {
      var slot = e.target.closest('[data-slot]');
      if (!slot) return;
      state.order.splice(Number(slot.dataset.slot), 1);
      render();
    });

    add.addEventListener('click', function () {
      if (state.order.length !== state.size) return;
      var label = data.bundleName + ' (' + state.size + ')';
      var bundleId = Date.now().toString(36);
      var lines = {};
      var items = [];
      function put(id) {
        if (lines[id]) lines[id].quantity++;
        else items.push(lines[id] = { id: Number(id), quantity: 1, properties: { Bundle: label, _bundle: bundleId } });
      }
      var pack = matchingPack();
      if (pack) put(pack.id);
      else state.order.forEach(function (key) { put(byKey[key].dataset.variant); });
      add.disabled = true;
      add.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); }); })
        .then(function () {
          add.disabled = false;
          add.textContent = data.addLabel;
          if (window.sdpCart) window.sdpCart.open();
          else window.location.href = '/cart';
        })
        .catch(function (err) {
          add.disabled = false;
          add.textContent = data.addLabel;
          saveEl.textContent = err.message;
        });
    });

    // No size is picked until the shopper chooses one.
    render();
  }
  document.querySelectorAll('[data-sdp-builder]').forEach(function (root) {
    if (root.querySelector('[data-sdp-builder-data]')) initBuilder(root);
  });
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sdp-builder]');
    if (root && root.querySelector('[data-sdp-builder-data]')) initBuilder(root);
  });

  // Product page buy box: pick a pack (or variant), quantity, sticky bar.
  function initProductPage(root) {
    var form = root.querySelector('[data-sdp-pdp-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-sdp-pdp-id]');
    var hero = root.querySelector('[data-sdp-pdp-hero]');
    var price = root.querySelector('[data-sdp-pdp-price]');
    var compare = root.querySelector('[data-sdp-pdp-compare]');
    var add = form.querySelector('[data-sdp-pdp-add]');
    var sticky = root.querySelector('[data-sdp-pdp-sticky]');
    var stickyPrice = root.querySelector('[data-sdp-pdp-sticky-price]');
    var stickyLabel = root.querySelector('[data-sdp-pdp-sticky-label]');
    var stickyImg = root.querySelector('[data-sdp-pdp-sticky-img]');
    var stickyAdd = root.querySelector('[data-sdp-pdp-sticky-add]');
    var choices = [].slice.call(root.querySelectorAll('[data-sdp-pdp-choice]'));
    var addLabel = add.textContent;

    function showImage(src) {
      if (!hero || !src || hero.getAttribute('src') === src) return;
      hero.classList.add('is-swapping');
      setTimeout(function () {
        hero.removeAttribute('srcset');
        hero.src = src;
        hero.onload = function () { hero.classList.remove('is-swapping'); };
      }, 150);
    }
    function choose(btn) {
      choices.forEach(function (c) { c.setAttribute('aria-checked', c === btn ? 'true' : 'false'); });
      idInput.value = btn.dataset.id;
      price.textContent = btn.dataset.price;
      compare.textContent = btn.dataset.compare || '';
      var ok = btn.dataset.available === 'true';
      add.disabled = !ok;
      add.textContent = ok ? addLabel : 'Sold out';
      if (stickyAdd) { stickyAdd.disabled = !ok; stickyAdd.textContent = ok ? addLabel : 'Sold out'; }
      if (stickyPrice) stickyPrice.textContent = btn.dataset.price;
      if (stickyLabel) stickyLabel.textContent = btn.dataset.label;
      if (stickyImg && btn.dataset.thumb) { stickyImg.removeAttribute('srcset'); stickyImg.src = btn.dataset.thumb; }
      var stage = root.querySelector('[data-sdp-pdp-stage]');
      if (stage && btn.dataset.heroZoom) stage.style.setProperty('--sdp-hero-zoom', btn.dataset.heroZoom);
      showImage(btn.dataset.image);
      // Share/bookmark the chosen pack.
      if (btn.dataset.url && window.history.replaceState) window.history.replaceState({}, '', btn.dataset.url);
    }
    choices.forEach(function (c) {
      c.addEventListener('click', function () { choose(c); });
      if (c.getAttribute('aria-checked') === 'true' && stickyLabel) stickyLabel.textContent = c.dataset.label;
    });

    root.querySelectorAll('[data-sdp-pdp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-sdp-pdp-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
        var stage = root.querySelector('[data-sdp-pdp-stage]');
        if (stage) stage.style.setProperty('--sdp-hero-zoom', 1);
        showImage(t.dataset.sdpPdpThumb);
      });
    });

    var qty = form.querySelector('[data-sdp-pdp-qty-input]');
    form.querySelectorAll('[data-sdp-pdp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, Math.min(99, (parseInt(qty.value, 10) || 1) + Number(b.dataset.sdpPdpQty)));
      });
    });

    // Show the sticky bar once the main Add button is off screen.
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', hidden);
        sticky.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = hidden ? 0 : -1;
      }).observe(add);
    }
  }
  document.querySelectorAll('[data-sdp-pdp]').forEach(initProductPage);

  // Showcase pages: scroll progress, reveals, count-ups, carousel, colors.
  (function () {
    var scrollers = [].slice.call(document.querySelectorAll('[data-sdp-scroll]'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // --p goes 0 to 1: across a pinned (tall) section's scroll, or as a
    // normal section moves up through the window.
    function update() {
      var vh = window.innerHeight;
      scrollers.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var p;
        if (r.height > vh * 1.2) p = -r.top / (r.height - vh);
        else p = (vh - r.top) / (vh + r.height);
        p = reduce ? 1 : Math.max(0, Math.min(1, p));
        el.style.setProperty('--p', p.toFixed(4));
        if (el.hasAttribute('data-sdp-story')) story(el, p);
      });
    }
    function story(el, p) {
      var steps = el.querySelectorAll('.sdp-scstory__step');
      var i = Math.min(steps.length - 1, Math.floor(p * steps.length * 0.999));
      if (el._step === i) return;
      el._step = i;
      steps.forEach(function (st, n) { st.classList.toggle('is-active', n === i); });
      var st = steps[i];
      el.style.setProperty('--story-glow', st.dataset.glow);
      el.style.setProperty('--story-scale', st.dataset.scale);
      el.style.setProperty('--story-rotate', st.dataset.rotate + 'deg');
    }
    if (scrollers.length) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function countUp(el) {
      var target = parseFloat(el.dataset.sdpCount);
      if (isNaN(target) || reduce) return;
      var decimals = (el.dataset.sdpCount.split('.')[1] || '').length;
      var start = performance.now();
      (function frame(now) {
        var t = Math.min(1, (now - start) / 1400);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (t < 1) requestAnimationFrame(frame);
      })(start);
    }
    var reveals = document.querySelectorAll('[data-sdp-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-revealed');
          e.target.querySelectorAll('[data-sdp-count]').forEach(countUp);
          io.unobserve(e.target);
        });
      }, { threshold: 0.2 });
      reveals.forEach(function (el) { io.observe(el); });
    } else reveals.forEach(function (el) { el.classList.add('is-revealed'); });

    document.querySelectorAll('[data-sdp-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-sdp-carousel-track]');
      var dots = [].slice.call(root.querySelectorAll('[data-sdp-carousel-dot]'));
      // Optional arrows: one card at a time.
      [['[data-sdp-carousel-prev]', -1], ['[data-sdp-carousel-next]', 1]].forEach(function (a) {
        var btn = root.querySelector(a[0]);
        if (!btn) return;
        btn.addEventListener('click', function () {
          var card = track.children[0];
          var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 20) : track.clientWidth;
          track.scrollBy({ left: a[1] * step, behavior: 'smooth' });
        });
      });
      function edges() {
        var prev = root.querySelector('[data-sdp-carousel-prev]');
        var next = root.querySelector('[data-sdp-carousel-next]');
        if (prev) prev.disabled = track.scrollLeft < 8;
        if (next) next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 8;
      }
      track.addEventListener('scroll', edges, { passive: true });
      edges();
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          var card = track.children[i];
          track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.clientWidth) / 2, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', function () {
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, dist = Infinity;
        [].forEach.call(track.children, function (c, i) {
          var d = Math.abs(c.offsetLeft + c.clientWidth / 2 - mid);
          if (d < dist) { dist = d; best = i; }
        });
        dots.forEach(function (d, i) { d.setAttribute('aria-selected', i === best ? 'true' : 'false'); });
      }, { passive: true });
    });

    document.querySelectorAll('[data-sdp-colors]').forEach(function (root) {
      var name = root.querySelector('[data-sdp-color-name]');
      var link = root.querySelector('[data-sdp-color-link]');
      root.querySelectorAll('[data-sdp-color-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = dot.dataset.sdpColorDot;
          root.querySelectorAll('[data-sdp-color-dot]').forEach(function (d) { d.setAttribute('aria-checked', d === dot ? 'true' : 'false'); });
          root.querySelectorAll('[data-sdp-color-shot]').forEach(function (s) { s.classList.toggle('is-active', s.dataset.sdpColorShot === i); });
          name.textContent = dot.dataset.name;
          if (link && dot.dataset.link) link.href = dot.dataset.link;
        });
      });
    });
  })();

  // Product cards: show the chosen variant's price and availability.
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-sdp-variant-select]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var card = select.closest('[data-sdp-card]');
    var price = card.querySelector('[data-sdp-price]');
    var button = card.querySelector('[data-sdp-add]');
    if (price) price.textContent = option.getAttribute('data-price');
    if (button) {
      var available = option.getAttribute('data-available') === 'true';
      button.disabled = !available;
      button.textContent = available ? button.getAttribute('data-label') : button.getAttribute('data-sold-out');
    }
  });

  // Sticky header: publish its height (for jump offsets), shadow once
  // scrolled, and light up the button bar item whose row is on screen.
  (function () {
    var header = document.querySelector('[data-sdp-sticky-header]');
    if (header) {
      var headerBox = header.closest('#shopify-section-header') || header;
      var setHeight = function () { document.documentElement.style.setProperty('--sdp-header-h', headerBox.offsetHeight + 'px'); };
      setHeight();
      if (window.ResizeObserver) new ResizeObserver(setHeight).observe(headerBox);
      var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 4); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var nav = document.querySelector('[data-sdp-hnav]');
    if (!nav) return;
    // Menus (Buttons, Keychains, More): each drops down a slider of its
    // products; one open at a time.
    var menus = Array.prototype.slice.call(nav.querySelectorAll('[data-sdp-hnav-more]')).map(function (btn) {
      return { btn: btn, panel: document.getElementById(btn.getAttribute('aria-controls')) };
    }).filter(function (m) { return m.panel; });
    function setMore(open, menu) {
      menus.forEach(function (m) {
        var on = !!open && m === menu;
        m.btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        m.panel.hidden = !on;
      });
    }
    menus.forEach(function (m) {
      m.btn.addEventListener('click', function (e) { e.stopPropagation(); setMore(m.panel.hidden, m); });
    });
    if (menus.length) {
      document.addEventListener('click', function (e) {
        if (!menus.some(function (m) { return m.panel.contains(e.target); })) setMore(false);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMore(false); });
    }
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-sdp-hnav-target]'));
    function flash(row) {
      row.classList.add('is-target');
      setTimeout(function () { row.classList.remove('is-target'); }, 1400);
    }
    items.forEach(function (a) {
      a.addEventListener('click', function (e) {
        setMore(false);
        var row = document.getElementById(a.getAttribute('data-sdp-hnav-target'));
        if (!row) return; // not on this page: follow the link to the homepage
        e.preventDefault();
        row.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + row.id);
        flash(row);
      });
    });
    var target = location.hash && document.getElementById(location.hash.slice(1));
    if (target && target.classList.contains('sdp-row')) flash(target);
    if (!window.IntersectionObserver) return;
    var rows = items.map(function (a) { return document.getElementById(a.getAttribute('data-sdp-hnav-target')); }).filter(Boolean);
    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting; });
      var current = null;
      rows.forEach(function (r) { if (!current && visible[r.id]) current = r.id; });
      items.forEach(function (a) {
        var on = a.getAttribute('data-sdp-hnav-target') === current;
        if (on && !a.classList.contains('is-active') && a.parentNode.scrollWidth > a.parentNode.clientWidth) {
          a.parentNode.scrollTo({ left: a.offsetLeft - a.parentNode.clientWidth / 2 + a.offsetWidth / 2, behavior: 'smooth' });
        }
        a.classList.toggle('is-active', on);
      });
      // A menu lights up while one of its products is on screen.
      menus.forEach(function (m) { m.btn.classList.toggle('is-active', !!m.panel.querySelector('.is-active')); });
    }, { rootMargin: '-35% 0px -55% 0px' });
    rows.forEach(function (r) { io.observe(r); });
  })();

  // The hidden 30-second dance party: press the dancer in the header logo.
  // Counts down 30 seconds, plays a song from the page's button music (if
  // any), streaks the rainbow trail across the screen and bounces things.
  (function () {
    var trigger = document.querySelector('[data-sdp-party-trigger]');
    if (!trigger) return;
    var countEl = document.querySelector('[data-sdp-party-count]');
    var wordmark = document.querySelector('.sdp-logo__wordmark');
    var timer = null, audio = null, stripes = null, crowd = null, stopBtn = null, left = 0;
    var art = {};
    try { art = JSON.parse(document.querySelector('[data-sdp-party-art]').textContent); } catch (e) {}
    // Dancers and buttons scattered over the screen on a loose grid so they
    // don't pile up, each with its own size, move and tempo.
    function makeCrowd() {
      var el = document.createElement('div');
      el.className = 'sdp-party-crowd';
      var cols = window.innerWidth < 750 ? 3 : 6, rows = window.innerWidth < 750 ? 5 : 3;
      var moves = ['m-bob', 'm-spin', 'm-hop', 'm-shimmy'];
      var html = '', n = 0;
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          var dancer = (r + c) % 2 === 0 || !art.buttons;
          var src = dancer ? art.dancer : art.buttons[n % art.buttons.length];
          if (!src) continue;
          var w = dancer ? 90 + Math.random() * 80 : 70 + Math.random() * 60;
          if (window.innerWidth < 750) w *= 0.7;
          var x = (c + 0.15 + Math.random() * 0.5) / cols * 100;
          var y = (r + 0.2 + Math.random() * 0.5) / rows * 100;
          var move = dancer ? moves[(r * cols + c) % 4 === 1 ? 2 : (r * cols + c) % 4 === 2 ? 3 : 0] : moves[1 + (n % 2)];
          html += '<img src="' + src + '" alt="" class="' + move + (dancer ? ' is-dancer' : '') + '" style="left:calc(' + x.toFixed(1) + '% - ' + (w / 2).toFixed(0) + 'px);top:calc(' + y.toFixed(1) + '% - ' + (w / 2).toFixed(0) + 'px);--w:' + w.toFixed(0) + 'px;--d:' + (n * 0.07).toFixed(2) + 's;--t:' + (0.42 + Math.random() * 0.5).toFixed(2) + 's">';
          n++;
        }
      }
      el.innerHTML = html;
      return el;
    }
    function song() {
      if (art.song) return art.song;
      var lists = [];
      document.querySelectorAll('[data-sdp-music]').forEach(function (el) {
        try { var l = JSON.parse(el.getAttribute('data-sdp-music')); if (l.tracks && l.tracks.length) lists.push(l); } catch (e) {}
      });
      if (!lists.length) return null;
      var tracks = lists[Math.floor(Math.random() * lists.length)].tracks;
      return tracks[Math.floor(Math.random() * tracks.length)].url;
    }
    function end(finished) {
      clearInterval(timer);
      timer = null;
      document.documentElement.classList.remove('sdp-party');
      if (audio) { audio.pause(); audio = null; }
      if (stripes) { stripes.remove(); stripes = null; }
      if (crowd) { var c = crowd; crowd = null; c.classList.add('is-leaving'); setTimeout(function () { c.remove(); }, 450); }
      if (stopBtn) { var sb = stopBtn; stopBtn = null; sb.classList.add('is-leaving'); setTimeout(function () { sb.remove(); }, 350); }
      countEl.textContent = '';
      if (finished) {
        var done = document.createElement('div');
        done.className = 'sdp-party-done';
        done.textContent = 'That’s 30 seconds. Back to work! 🕺';
        document.body.appendChild(done);
        setTimeout(function () { done.remove(); }, 2600);
      }
    }
    function start() {
      left = 30;
      countEl.textContent = left;
      document.documentElement.classList.add('sdp-party');
      stripes = document.createElement('div');
      stripes.className = 'sdp-party-stripes';
      document.body.appendChild(stripes);
      crowd = makeCrowd();
      document.body.appendChild(crowd);
      stopBtn = document.createElement('button');
      stopBtn.type = 'button';
      stopBtn.className = 'sdp-party-stop';
      stopBtn.innerHTML = '<span class="sdp-party-stop__icon" aria-hidden="true"></span>Stop the party <span class="sdp-party-stop__count" data-sdp-party-stop-count>' + left + '</span>';
      stopBtn.addEventListener('click', function () { end(false); });
      document.body.appendChild(stopBtn);
      var url = song();
      if (url) { audio = new Audio(url); audio.loop = true; audio.play().catch(function () {}); }
      timer = setInterval(function () {
        left -= 1;
        countEl.textContent = left;
        var sc = stopBtn && stopBtn.querySelector('[data-sdp-party-stop-count]');
        if (sc) sc.textContent = left;
        if (left <= 0) end(true);
      }, 1000);
    }
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (timer) end(false); else start();
    });
    if (wordmark) {
      wordmark.addEventListener('mouseenter', function () {
        wordmark.classList.toggle('is-replay');
      });
    }
  })();

  // Background YouTube videos: swap the poster for the muted looping embed
  // once it's near the screen (skipped when the visitor prefers less motion).
  (function () {
    var els = document.querySelectorAll('[data-sdp-bg-video]');
    if (!els.length || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    function load(el) {
      if (el.firstChild) return;
      var f = document.createElement('iframe');
      f.src = el.getAttribute('data-sdp-bg-video');
      f.allow = 'autoplay; encrypted-media';
      f.tabIndex = -1;
      f.title = '';
      f.addEventListener('load', function () { setTimeout(function () { el.classList.add('is-playing'); }, 900); });
      el.appendChild(f);
    }
    if (!('IntersectionObserver' in window)) return els.forEach(load);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { load(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '400px 0px' });
    els.forEach(function (el) { io.observe(el); });
  })();

  // Add-on rows (e.g. Button + Necklace): the picker updates the price and photo.
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sdp-addon-select]');
    if (!sel) return;
    var o = sel.options[sel.selectedIndex];
    var row = sel.closest('[data-sdp-addon]');
    row.querySelector('[data-sdp-addon-price]').textContent = o.getAttribute('data-price');
    var img = row.querySelector('[data-sdp-addon-img]');
    if (img && o.getAttribute('data-image')) { img.removeAttribute('srcset'); img.src = o.getAttribute('data-image'); }
  });

  // Store picker in the header: tap to open (hover opens it on desktop).
  document.querySelectorAll('[data-sdp-region]').forEach(function (root) {
    var btn = root.querySelector('.sdp-region__btn');
    function set(open) { root.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); set(!root.classList.contains('is-open')); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  });

  // Slide-out cart (snippets/sdp-cart-drawer.liquid). Add-to-cart forms and
  // the header cart icon open it instead of going to the cart page.
  function initCartDrawer(root) {
    var cfg = JSON.parse(root.querySelector('[data-sdp-drawer-data]').textContent);
    var panel = root.querySelector('.sdp-drawer__panel');
    var linesEl = root.querySelector('[data-sdp-drawer-lines]');
    var foot = root.querySelector('[data-sdp-drawer-foot]');
    var totalEl = root.querySelector('[data-sdp-drawer-total]');
    var savingsEl = root.querySelector('[data-sdp-drawer-savings]');
    var countEl = root.querySelector('[data-sdp-drawer-count]');
    var shipEl = root.querySelector('[data-sdp-drawer-ship]');
    var offersEl = root.querySelector('[data-sdp-drawer-offers]');
    var offers = {};
    try { offers = JSON.parse(root.querySelector('[data-sdp-drawer-offers-data]').textContent); } catch (e) {}
    // Free shipping helpers: estimate the bundle discount after adding a button
    // (same tiers as the automatic discounts), and pick the cheapest single
    // that gets the order over the line.
    function tierPct(n) {
      var pct = 0;
      (offers.tiers || []).forEach(function (t) { if (n >= t.qty) pct = t.pct; });
      return pct;
    }
    // Buttons in the cart for the bundle tier, counting the ones in packs
    // ("2-pack", "(5-pack)"), like the discount function does.
    // Single buttons the bundle discount applies to: the offer buttons, and Kitty / Dino (pairs).
    function bundleIds() {
      var ids = {};
      (offers.buttons || []).forEach(function (b) { ids[b.id] = true; });
      (offers.pairs || []).forEach(function (p) { ids[p.id] = true; });
      return ids;
    }
    function bundleCount() {
      var ids = bundleIds();
      var buttonProducts = offers.buttonProducts || [];
      return cart.items.reduce(function (n, i) {
        var isButton = ids[i.variant_id] || buttonProducts.indexOf(i.product_id) > -1 || inList(offers.keychainProducts, i.product_id);
        if (!isButton) return n;
        var m = String(i.variant_title || '').match(/(\d+)\s*-?\s*pack/i) || String(i.product_title || '').match(/(\d+)\s*-?\s*pack/i);
        return n + i.quantity * (m ? Math.max(1, Number(m[1])) : 1);
      }, 0);
    }
    function bundleSubtotal() {
      var ids = bundleIds();
      return cart.items.reduce(function (n, i) { return n + (ids[i.variant_id] ? i.original_line_price : 0); }, 0);
    }
    // Checkout offer (full screen, on Checkout), by distance to free shipping:
    //  - under $20 away: one or two items that get the order there (a button,
    //    with the bundle discount it unlocks, or a $4.99 accessory);
    //  - $20+ away, or free shipping already: "Accessorize?" with the Necklace
    //    (any button in the cart) and the Party Light (a Volume 3 or 4), $4.99 each.
    // Nothing relevant: straight to checkout.
    var V3V4_TITLE = /\b(volume\s*[34]|v[34])\b/i;
    function inList(list, id) { return (list || []).indexOf(id) > -1; }
    function accessories() {
      var have = {};
      var buttons = false, v34 = false;
      cart.items.forEach(function (i) {
        have[i.variant_id] = true;
        // Keychains (Kitty, Dino and their packs) don't take the Necklace.
        if (inList(offers.buttonProducts, i.product_id) && !inList(offers.keychainProducts, i.product_id)) {
          buttons = true;
          if (inList(offers.v3v4Products, i.product_id) || V3V4_TITLE.test(i.variant_title || '')) v34 = true;
        }
      });
      var list = [];
      var nk = offers.necklace, lt = offers.light;
      // A Button + Necklace already brings one.
      var hasNecklace = cart.items.some(function (i) { return i.handle === 'button-necklace'; });
      if (buttons && !hasNecklace && nk && nk.available && !have[nk.id]) list.push({ id: nk.id, image: nk.image, name: 'The Necklace', note: 'Wear your button for hands-free dancing.', was: nk.price, now: nk.offer });
      if (v34 && lt && lt.available && !have[lt.id]) list.push({ id: lt.id, image: lt.image, name: 'The Party Light', note: 'Lights up the room with your Volume 3 or 4.', was: lt.price, now: lt.offer });
      return list;
    }
    function shippingOptions(goal) {
      var have = {};
      cart.items.forEach(function (i) { have[i.variant_id] = true; });
      var n = bundleCount(), before = bundleSubtotal();
      var pctBefore = tierPct(n), pctAfter = tierPct(n + 1);
      var otherTotal = cart.total_price - Math.round(before * (1 - pctBefore / 100));
      var opts = [];
      (offers.buttons || []).forEach(function (b) {
        if (!b.available) return;
        var newTotal = otherTotal + Math.round((before + b.price) * (1 - pctAfter / 100));
        if (newTotal < goal) return;
        opts.push({ id: b.id, image: b.image, name: b.title, was: b.price, now: Math.round(b.price * (1 - pctAfter / 100)),
          note: pctAfter > pctBefore ? 'Plus ' + pctAfter + '% off your buttons' : (pctAfter ? 'With your ' + pctAfter + '% bundle discount' : 'Free shipping on your whole order'),
          score: newTotal + (have[b.id] ? 500 : 0) + (b.single ? 0 : 300) });
      });
      accessories().forEach(function (a) {
        if (cart.total_price + a.now >= goal) opts.push({ id: a.id, image: a.image, name: a.name, note: a.note, was: a.was, now: a.now, score: cart.total_price + a.now - 1000 });
      });
      opts.sort(function (x, y) { return x.score - y.score; });
      return opts.slice(0, 2);
    }
    // A single Kitty without a Dino (or back): the other one, at the 2-button bundle discount.
    function pairOffer() {
      var pair = (offers.pairs || []).filter(function (p) {
        return p.other.available && cart.items.some(function (i) { return i.variant_id === p.id; }) &&
          !cart.items.some(function (i) { return i.product_id === p.other.product; });
      })[0];
      if (!pair) return null;
      var n = bundleCount(), pctBefore = tierPct(n), pctAfter = tierPct(n + 1);
      var o = pair.other;
      // Price it at what it adds to the order: the whole bundle saving shown on
      // this one (e.g. 10% off both = 20% off the second button).
      var before = bundleSubtotal();
      var now = Math.round((before + o.price) * (1 - pctAfter / 100)) - Math.round(before * (1 - pctBefore / 100));
      var pct = Math.round((1 - now / o.price) * 100);
      var item = { id: o.id, image: o.image, name: o.name, was: o.price, now: now, note: pct > 0 ? pct + '% off with your ' + pair.name : '' };
      return { eyebrow: 'Make it a pair', title: 'Add a ' + o.name + ' to your ' + pair.name + '?',
        text: pct > 0 ? 'Get the ' + o.name + ' for ' + pct + '% off. Dance-off ready.' : 'Ready for a dance-off.', items: [item] };
    }
    // A cart of only keychains (Kitty, Dino and their packs) short of free
    // shipping, at any distance: whichever button product gets it there,
    // landing at most $20 past the line, closest first (keychains ahead on a
    // near tie). Bundle singles get the bundle discount; packs and bundles
    // count their buttons toward it. Lights / Necklaces only come with a
    // button they work with, so on their own they stay out of it.
    function keychainOnly() {
      return cart.items.length > 0 && cart.items.every(function (i) { return inList(offers.keychainProducts, i.product_id); });
    }
    function gapOptions(goal) {
      var ids = bundleIds(), have = {};
      cart.items.forEach(function (i) { have[i.variant_id] = true; });
      var n = bundleCount(), before = bundleSubtotal(), pctBefore = tierPct(n);
      var otherTotal = cart.total_price - Math.round(before * (1 - pctBefore / 100));
      var opts = [];
      (offers.gap || []).forEach(function (g) {
        if (!g || !g.available || have[g.id]) return;
        var single = !!ids[g.id];
        var m = !single && (String(g.title).match(/(\d+)\s*-?\s*pack/i) || String(g.productTitle).match(/(\d+)\s*-?\s*pack/i));
        var pctAfter = tierPct(n + (m ? Math.max(1, Number(m[1])) : 1));
        var newTotal = single
          ? otherTotal + Math.round((before + g.price) * (1 - pctAfter / 100))
          : otherTotal + Math.round(before * (1 - pctAfter / 100)) + g.price;
        if (newTotal < goal || newTotal - goal > 2000) return;
        var added = newTotal - cart.total_price;
        opts.push({ id: g.id, image: g.image, name: g.name, was: g.price, now: g.price - added >= 10 ? added : g.price,
          note: pctAfter > pctBefore ? 'Free shipping, plus ' + pctAfter + '% off your buttons' : 'Free shipping on your whole order',
          score: newTotal + (g.keychain ? 0 : 100) });
      });
      opts.sort(function (x, y) { return x.score - y.score; });
      return opts.slice(0, 2);
    }
    function checkoutOffer() {
      var goal = window.sdpLocalCents(Number(cfg.freeShipping) || 0);
      if (!cart || !cart.item_count) return null;
      var pair = pairOffer();
      if (pair) return pair;
      if (goal && keychainOnly() && cart.total_price < goal) {
        var gap = gapOptions(goal);
        var short = goal - cart.total_price;
        if (gap.length) return { eyebrow: 'Almost there', title: 'You’re ' + money(short) + ' away from free shipping.', text: gap.length > 1 ? 'Add either one and your whole order ships free.' : 'Add it and your whole order ships free.', items: gap };
        return null;
      }
      var left = goal ? Math.max(0, goal - cart.total_price) : 0;
      if (left > 0 && left < 2000) {
        var opts = shippingOptions(goal);
        if (opts.length) return { eyebrow: 'Almost there', title: 'You’re ' + money(left) + ' away from free shipping.', text: opts.length > 1 ? 'Add either one and your whole order ships free.' : 'Add it and your whole order ships free.', items: opts };
      }
      var acc = accessories();
      if (!acc.length) return null;
      return { eyebrow: left === 0 && goal ? 'You’ve got free shipping' : 'Before you go', title: 'Accessorize?', text: (acc.length > 1 ? 'Each just ' : 'Just ') + money(acc[0].now) + ' with your button.', items: acc };
    }
    var upsell = null;
    function showCheckoutOffer(o) {
      if (!upsell) {
        upsell = document.createElement('div');
        upsell.className = 'sdp-upsell';
        upsell.setAttribute('role', 'dialog');
        upsell.setAttribute('aria-modal', 'true');
        document.body.appendChild(upsell);
        upsell.addEventListener('click', function (e) {
          if (e.target.closest('[data-sdp-upsell-back]')) { upsell.classList.remove('is-open'); open(); return; }
          if (e.target.closest('[data-sdp-upsell-checkout]')) { location.href = '/checkout'; return; }
          var add = e.target.closest('[data-sdp-upsell-add]');
          if (!add || add.classList.contains('is-added')) return;
          add.disabled = true;
          add.classList.add('is-busy');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(add.getAttribute('data-sdp-upsell-add')), quantity: 1 }] })
          }).then(function (r) {
            add.classList.remove('is-busy');
            if (!r.ok) { add.disabled = false; return; }
            // Only one thing on offer: added, so straight on to checkout.
            if (upsell.querySelectorAll('[data-sdp-upsell-add]').length === 1) { location.href = '/checkout'; return; }
            add.classList.add('is-added');
            add.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg> Added';
            var go = upsell.querySelector('[data-sdp-upsell-checkout]');
            go.textContent = 'Check out';
            go.classList.add('is-primary');
            refresh();
          }, function () { add.disabled = false; add.classList.remove('is-busy'); });
        });
      }
      var rows = o.items.map(function (it) {
        var price = it.was > it.now ? '<s>' + money(it.was) + '</s> <b>' + money(it.now) + '</b>' : '<b>' + money(it.now) + '</b>';
        return '<div class="sdp-upsell__item">' + (it.image ? '<img src="' + esc(it.image) + '" alt="">' : '') +
          '<div class="sdp-upsell__info"><strong>' + esc(it.name) + '</strong><span class="sdp-upsell__price">' + price + '</span>' +
          (it.note ? '<span class="sdp-upsell__note">' + esc(it.note) + '</span>' : '') + '</div>' +
          '<button type="button" class="sdp-upsell__add" data-sdp-upsell-add="' + it.id + '">Add</button></div>';
      }).join('');
      upsell.innerHTML =
        '<div class="sdp-upsell__panel">' +
          '<button type="button" class="sdp-upsell__back" data-sdp-upsell-back aria-label="Back to cart">' +
            '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
          '<p class="sdp-upsell__eyebrow">' + esc(o.eyebrow) + '</p>' +
          '<h2 class="sdp-upsell__title">' + esc(o.title) + '</h2>' +
          '<p class="sdp-upsell__text">' + esc(o.text) + '</p>' +
          '<div class="sdp-upsell__items">' + rows + '</div>' +
          '<button type="button" class="sdp-upsell__go" data-sdp-upsell-checkout>No thanks, check out</button>' +
        '</div>';
      close();
      requestAnimationFrame(function () { requestAnimationFrame(function () { upsell.classList.add('is-open'); }); });
    }
    root.addEventListener('submit', function (e) {
      if (!e.target.classList.contains('sdp-drawer__checkout-form')) return;
      var o = checkoutOffer();
      if (!o) return;
      e.preventDefault();
      showCheckoutOffer(o);
    });
    var lastFocus = null;
    var cart = null;

    function money(cents) {
      var fmt = cfg.moneyFormat || '${{amount}}';
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, kind) {
        var n = (cents / 100).toFixed(/no_decimals/.test(kind) ? 0 : 2).split('.');
        n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, /comma_separator/.test(kind) ? '.' : ',');
        return n.join(/comma_separator/.test(kind) ? ',' : '.');
      });
    }
    function esc(t) {
      return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
    }
    function img(url, w) {
      return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '';
    }

    function lineHtml(item, inBundle) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var was = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
      var controls = inBundle
        ? '<span class="sdp-drawer__qty-fixed">&times; ' + item.quantity + '</span>'
        : '<div class="sdp-drawer__qty" role="group" aria-label="Quantity">' +
            '<button type="button" data-sdp-qty="' + esc(item.key) + '" data-to="' + (item.quantity - 1) + '" aria-label="One fewer">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-sdp-qty="' + esc(item.key) + '" data-to="' + (item.quantity + 1) + '" aria-label="One more">+</button>' +
          '</div>' +
          '<button type="button" class="sdp-drawer__remove" data-sdp-qty="' + esc(item.key) + '" data-to="0">Remove</button>';
      return '<div class="sdp-drawer__line">' +
        '<a class="sdp-drawer__img" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(img(item.image, 180)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="sdp-drawer__info">' +
          '<a class="sdp-drawer__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (variant ? '<span class="sdp-drawer__variant">' + esc(variant) + '</span>' : '') +
          (item.properties && item.properties._gift_school ? '<span class="sdp-drawer__gift-tag">🎁 Gift for ' + esc(item.properties['Gift for'] || 'a school') + (item.properties.Grade && item.properties.Grade !== 'Whoever needs it' ? ' · ' + esc(item.properties.Grade) : '') + '</span>' : '') +
          '<div class="sdp-drawer__controls">' + controls + '</div>' +
        '</div>' +
        '<div class="sdp-drawer__price">' + was + '<span>' + money(item.final_line_price) + '</span></div>' +
      '</div>';
    }

    function render() {
      var count = cart.item_count;
      countEl.textContent = count ? '(' + count + ')' : '';
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
      document.querySelectorAll('[data-cart-count-bubble]').forEach(function (el) { el.classList.toggle('hide', !count); });
      foot.hidden = !count;
      // Free shipping progress, on the total after discounts.
      if (shipEl) {
        var goal = window.sdpLocalCents(Number(cfg.freeShipping) || 0);
        var left = Math.max(0, goal - cart.total_price);
        shipEl.hidden = !count || !goal;
        shipEl.classList.toggle('is-free', left === 0);
        shipEl.querySelector('[data-sdp-drawer-ship-fill]').style.width = (goal ? Math.min(100, cart.total_price / goal * 100) : 0) + '%';
        // Offers moved out of the drawer: shown full screen on Checkout instead (checkoutOffer).
        shipEl.querySelector('[data-sdp-drawer-ship-text]').innerHTML = left === 0
          ? '<strong>You\u2019ve got free shipping!</strong>' + (cfg.freeShippingNote ? ' <span>(' + esc(cfg.freeShippingNote) + ')</span>' : '')
          : 'You\u2019re <strong>' + money(left) + '</strong> away from free shipping';
      }
      if (!count) {
        linesEl.innerHTML = '<div class="sdp-drawer__empty"><p>Your cart is empty.</p><a href="' + esc(cfg.allUrl) + '" class="sdp-drawer__checkout" data-sdp-drawer-find>Find your button</a></div>';
        return;
      }
      // Bundle lines (from Build Your Bundle) are grouped and removed together.
      var html = '';
      var bundles = {};
      cart.items.forEach(function (item) {
        var b = item.properties && item.properties._bundle;
        if (!b) { html += lineHtml(item, false); return; }
        if (!bundles[b]) {
          bundles[b] = { name: item.properties.Bundle || 'Bundle', items: [] };
          html += '<!--bundle:' + b + '-->';
        }
        bundles[b].items.push(item);
      });
      Object.keys(bundles).forEach(function (b) {
        var g = bundles[b];
        var keys = g.items.map(function (i) { return i.key; }).join(',');
        var group = '<div class="sdp-drawer__bundle">' +
          '<div class="sdp-drawer__bundle-head"><span>' + esc(g.name) + '</span>' +
          '<button type="button" class="sdp-drawer__remove" data-sdp-remove-bundle="' + esc(keys) + '">Remove bundle</button></div>' +
          g.items.map(function (i) { return lineHtml(i, true); }).join('') +
        '</div>';
        html = html.replace('<!--bundle:' + b + '-->', group);
      });
      // School gifts: a thank-you up top.
      var giftSchools = [];
      cart.items.forEach(function (i) { var n = i.properties && i.properties._gift_school && i.properties['Gift for']; if (n && giftSchools.indexOf(n) < 0) giftSchools.push(n); });
      if (giftSchools.length) {
        html = '<div class="sdp-drawer__gift"><span class="sdp-drawer__gift-icon" aria-hidden="true">🎉</span><div><strong>Thank you for gifting a dance party!</strong>' +
          '<span>' + esc(giftSchools.join(' & ')) + (giftSchools.length > 1 ? ' are' : ' is') + ' about to get a lot more fun. We’ll ship it straight to the school.</span></div></div>' + html;
      }
      linesEl.innerHTML = html;

      // Savings, by discount (e.g. "Build Your Bundle: 10% off 2+ buttons").
      var saved = {};
      cart.items.forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (a) {
          var t = a.discount_application.title;
          saved[t] = (saved[t] || 0) + a.amount;
        });
      });
      (cart.cart_level_discount_applications || []).forEach(function (a) {
        saved[a.title] = (saved[a.title] || 0) + a.total_allocated_amount;
      });
      savingsEl.innerHTML = Object.keys(saved).map(function (t) {
        return '<div class="sdp-drawer__saving"><span>' + esc(t) + '</span><span>&minus;' + money(saved[t]) + '</span></div>';
      }).join('');
      totalEl.textContent = money(cart.total_price);
    }

    function refresh() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cart = c; render(); syncCurrencyRate(c); });
    }
    // Global store: checkout can't read Shopify.currency.rate, so the cart
    // carries it ("GBP:0.7891") for the checkout free-shipping block
    // (30sdp-orders-page extensions/checkout-free-shipping) to convert the
    // $45 line and $4.99 add-ons the same way.
    function syncCurrencyRate(c) {
      var cur = window.Shopify && Shopify.currency;
      var rate = Number(cur && cur.rate) || 1;
      if (!c.item_count || !cur || (rate === 1 && !(c.attributes || {})._currency_rate)) return;
      var value = cur.active + ':' + rate;
      if ((c.attributes || {})._currency_rate === value) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _currency_rate: value } })
      }).then(function (r) { return r.json(); }).then(function (u) { cart = u; }, function () {});
    }
    function busy(on) { panel.classList.toggle('is-busy', on); }

    function open() {
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('sdp-drawer-open');
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
      panel.focus();
      busy(true);
      return refresh().then(function () { busy(false); });
    }
    function close() {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('sdp-drawer-open');
      setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 350);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sdp-drawer-close]')) return close();
      // Already on the homepage: close the cart and glide to the bundle builder.
      var find = e.target.closest('[data-sdp-drawer-find]');
      var target = find && document.getElementById('bundle');
      if (target) { e.preventDefault(); close(); setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250); return; }
      var q = e.target.closest('[data-sdp-qty]');
      var rb = e.target.closest('[data-sdp-remove-bundle]');
      var oa = e.target.closest('[data-sdp-offer-add]');
      if (oa) {
        oa.disabled = true;
        busy(true);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(oa.getAttribute('data-sdp-offer-add')), quantity: 1 }] })
        }).then(refresh).then(function () { busy(false); }, function () { busy(false); });
        return;
      }
      var req;
      if (q) {
        req = fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: q.getAttribute('data-sdp-qty'), quantity: Number(q.getAttribute('data-to')) })
        });
      } else if (rb) {
        var updates = {};
        rb.getAttribute('data-sdp-remove-bundle').split(',').forEach(function (k) { updates[k] = 0; });
        req = fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      }
      if (!req) return;
      busy(true);
      req.then(refresh).then(function () { busy(false); }, function () { busy(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // Header cart icon.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a.site-header__cart');
      if (!link || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      open();
    });

    // Any add-to-cart form. Captured here, before the theme's own handler,
    // so every add (cards, packs, product pages) lands in the drawer.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || !/\/cart\/add(\?|$)/.test(form.getAttribute('action') || '')) return;
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      e.stopPropagation();
      var buttons = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
      if (form.id) buttons = buttons.concat(Array.prototype.slice.call(document.querySelectorAll('[type="submit"][form="' + form.id + '"]')));
      buttons.forEach(function (b) { b.classList.add('is-adding'); b.disabled = true; });
      var done = function () { buttons.forEach(function (b) { b.classList.remove('is-adding'); b.disabled = false; }); };
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); }); })
        .then(function () { done(); open(); })
        .catch(function (err) { done(); window.alert(err.message); });
    }, true);

    window.sdpCart = { open: open, close: close, refresh: refresh };
  }
  document.querySelectorAll('[data-sdp-drawer]').forEach(initCartDrawer);
})();

/* Email sign-up: the footer form and the full-screen popup post to the
   sign-up endpoint (Moosend list + the $5 code by email). sdpSignup resolves
   { ok } on success, { error } for a problem to show (bad email, too many
   tries), and rejects when the endpoint can't be reached. */
function sdpSignup(endpoint, email, source, hp) {
  return fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: String(email || '').trim(), source: source || 'website', website: hp || '' })
  })
    .then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; });
    })
    .then(function (res) {
      if (res.body && res.body.ok) return { ok: true };
      if (res.status === 400 || res.status === 429) return { error: res.body.error || 'Please check your email address.' };
      throw new Error('signup ' + res.status);
    });
}
// Fallback when the endpoint is down: a Shopify customer sign-up (tagged newsletter).
function sdpShopifySignup(email) {
  var body = new URLSearchParams();
  body.set('form_type', 'customer');
  body.set('utf8', '✓');
  body.set('contact[email]', String(email || '').trim());
  body.set('contact[tags]', 'newsletter');
  return fetch('/contact', { method: 'POST', body: body, credentials: 'same-origin' });
}

(function () {
  document.querySelectorAll('form[data-sdp-signup]').forEach(function (form) {
    var endpoint = form.getAttribute('data-sdp-signup');
    if (!endpoint) return;
    var status = form.querySelector('.sdp-footer__status');
    var button = form.querySelector('button[type="submit"]');
    function say(text, ok) {
      if (!status) return;
      status.hidden = false;
      status.textContent = text;
      status.classList.toggle('is-error', !ok);
    }
    form.addEventListener('submit', function (e) {
      if (form.dataset.sdpFallback) return;
      e.preventDefault();
      var email = (form.querySelector('input[type="email"]') || {}).value || '';
      var hp = (form.querySelector('input[name="website"]') || {}).value || '';
      button.disabled = true;
      sdpSignup(endpoint, email, form.getAttribute('data-sdp-signup-source') || 'website', hp)
        .then(function (res) {
          button.disabled = false;
          if (res.ok) {
            form.classList.add('is-done');
            say('You’re on the list! 🎉 Check your inbox for your $5 code.', true);
            try { document.cookie = 'sdp_signup=done; path=/; max-age=31536000; samesite=lax'; } catch (err) {}
          } else say(res.error, false);
        })
        .catch(function () {
          // Endpoint unreachable: fall back to the Shopify customer sign-up.
          form.dataset.sdpFallback = '1';
          button.disabled = false;
          HTMLFormElement.prototype.submit.call(form);
        });
    });
  });
})();

/* Full-screen sign-up (snippets/sdp-signup-modal.liquid): once per visitor,
   a few seconds after the page loads. Closing or signing up sets a cookie
   (sdp_signup) for a year so it never comes back. Add ?signup=1 to a URL to
   preview it again. */
(function initSignupModal() {
  var root = document.querySelector('[data-sdp-signup-modal]');
  if (!root) return;
  var preview = /[?&]signup=1\b/.test(location.search);
  var seen = /(?:^|;\s*)sdp_signup=/.test(document.cookie);
  try { if (localStorage.getItem('sdp_signup')) seen = true; } catch (e) {}
  // People arriving from our own emails are already on the list.
  if (!preview && (seen || /[?&]utm_medium=email\b/i.test(location.search))) return;
  var dialog = root.querySelector('.sdp-signup__dialog');
  var form = root.querySelector('[data-sdp-signup-form]');
  var input = form.querySelector('input[type="email"]');
  var submit = form.querySelector('[type="submit"]');
  var err = form.querySelector('.sdp-signup__error');
  var lastFocus = null;

  function remember(value) {
    try { document.cookie = 'sdp_signup=' + value + '; path=/; max-age=31536000; samesite=lax'; } catch (e) {}
    try { localStorage.setItem('sdp_signup', value); } catch (e) {}
  }
  function show() {
    // Not over an open cart, and not twice.
    if (root.classList.contains('is-open') || document.documentElement.classList.contains('sdp-drawer-open')) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('sdp-signup-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    setTimeout(function () { if (window.matchMedia('(min-width: 750px)').matches) input.focus(); else dialog.focus(); }, 450);
    if (window.dataLayer) window.dataLayer.push({ event: 'sdp_signup_shown' });
  }
  function close() {
    if (!root.classList.contains('is-done')) remember('closed');
    root.classList.remove('is-open');
    document.documentElement.classList.remove('sdp-signup-open');
    setTimeout(function () { root.hidden = true; }, 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function done(withCode) {
    remember('done');
    root.classList.add('is-done');
    root.querySelector('.sdp-signup__form-view').hidden = true;
    var view = root.querySelector('.sdp-signup__done-view');
    if (!withCode) {
      view.querySelector('[data-sdp-signup-done-title]').textContent = 'You’re on the list. 🎉';
      view.querySelector('[data-sdp-signup-done-text]').textContent = 'Watch your inbox for new buttons and deals.';
    }
    view.hidden = false;
    if (window.dataLayer) window.dataLayer.push({ event: 'sdp_signup', source: 'popup' });
  }
  function fail(text) {
    err.hidden = false;
    err.textContent = text;
    input.setAttribute('aria-invalid', 'true');
    input.focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-sdp-signup-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    err.hidden = true;
    input.removeAttribute('aria-invalid');
    var email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return fail('Please enter a valid email address.');
    submit.disabled = true;
    submit.classList.add('is-busy');
    var hp = (form.querySelector('input[name="website"]') || {}).value || '';
    var endpoint = root.getAttribute('data-endpoint');
    var go = endpoint ? sdpSignup(endpoint, email, 'popup', hp) : Promise.reject(new Error('no endpoint'));
    go.then(function (res) {
      if (res.ok) return done(true);
      fail(res.error);
    })
      .catch(function () {
        // Endpoint unreachable: still add them (Shopify customer sign-up).
        return sdpShopifySignup(email).then(function () { done(false); }, function () { fail('Something went wrong. Please try again.'); });
      })
      .then(function () { submit.disabled = false; submit.classList.remove('is-busy'); });
  });

  var delay = Math.max(0, Number(root.getAttribute('data-delay')) || 0) * 1000;
  setTimeout(show, preview ? 300 : delay);
})();

/* Wholesale rep finder (sections/sdp-wholesale.liquid): the map is colored
   by rep group; clicking a state, a legend entry, or entering a ZIP code /
   address shows that group's contact. ZIP codes map to states by their
   first three digits (USPS ranges), so nothing leaves the page. */
(function initRepFinder() {
  var root = document.querySelector('[data-sdp-reps]');
  if (!root) return;
  var reps = [];
  try { reps = JSON.parse(root.querySelector('[data-sdp-reps-data]').textContent); } catch (e) { return; }
  var map = root.querySelector('[data-sdp-reps-map] svg');
  var result = root.querySelector('[data-sdp-reps-result]');
  var input = root.querySelector('[data-sdp-reps-input]');
  var byState = {};
  reps.forEach(function (r, i) { (r.states || []).forEach(function (st) { if (st) byState[st] = i; }); });
  var NAMES = {AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',DC:'Washington, DC',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming'};
  // First three ZIP digits -> state: [from, to, state], checked in order (exceptions first).
  var ZIPS = [[55,55,'MA'],[201,201,'VA'],[569,569,'DC'],[733,733,'TX'],[885,885,'TX'],[5,5,'NY'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[398,399,'GA'],[320,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[889,898,'NV'],[900,961,'CA'],[967,968,'HI'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  function stateFromZip(zip) {
    var p = parseInt(zip.slice(0, 3), 10);
    for (var i = 0; i < ZIPS.length; i++) if (p >= ZIPS[i][0] && p <= ZIPS[i][1]) return ZIPS[i][2];
    return null;
  }
  function stateFromText(q) {
    // The ZIP is the last 5-digit number (a street number can come first).
    var zips = q.match(/\b\d{5}(?=(?:-\d{4})?\b)/g);
    if (zips) return stateFromZip(zips[zips.length - 1]);
    var lower = q.toLowerCase();
    // Full names, longest first ("West Virginia" before "Virginia").
    var names = Object.keys(NAMES).sort(function (a, b) { return NAMES[b].length - NAMES[a].length; });
    for (var i = 0; i < names.length; i++) {
      if (new RegExp('\\b' + NAMES[names[i]].toLowerCase().replace(/[.,]/g, '') + '\\b').test(lower.replace(/[.,]/g, ' '))) return names[i];
    }
    // A two-letter code: just the code, or after a comma ("Portland, OR").
    var t = q.trim().toUpperCase();
    if (NAMES[t]) return t;
    var m = q.match(/,\s*([A-Za-z]{2})\b(?!.*,\s*[A-Za-z]{2}\b)/);
    if (m && NAMES[m[1].toUpperCase()]) return m[1].toUpperCase();
    return null;
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var paths = map ? map.querySelectorAll('[data-state]') : [];
  Array.prototype.forEach.call(paths, function (p) {
    var i = byState[p.getAttribute('data-state')];
    if (i != null) p.style.setProperty('--rep', reps[i].color);
    else p.classList.add('is-uncovered');
  });

  // The chosen group lifts: its states (and labels) move into a layer on top
  // that grows a little with a drop shadow; the picked state is outlined.
  var statesLayer = map && map.querySelector('.sdp-usmap__states');
  var labelsLayer = map && map.querySelector('.sdp-usmap__labels');
  var lift = null;
  function highlight(i, state) {
    if (map) {
      if (lift) {
        lift.querySelectorAll('[data-state]').forEach(function (p) { statesLayer.appendChild(p); });
        lift.querySelectorAll('[data-label]').forEach(function (t) { labelsLayer.appendChild(t); });
        lift.remove();
        lift = null;
      }
      if (i != null) {
        lift = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        lift.setAttribute('class', 'sdp-usmap__lift');
        var picked = null;
        Array.prototype.forEach.call(paths, function (p) {
          var st = p.getAttribute('data-state');
          if (byState[st] !== i) return;
          if (st === state) picked = p; else lift.appendChild(p);
        });
        if (picked) lift.appendChild(picked);
        reps[i].states.forEach(function (st) { var t = labelsLayer.querySelector('[data-label="' + st + '"]'); if (t) lift.appendChild(t); });
        map.appendChild(lift);
        requestAnimationFrame(function () { requestAnimationFrame(function () { if (lift) lift.classList.add('is-up'); }); });
      }
    }
    Array.prototype.forEach.call(paths, function (p) {
      p.classList.toggle('is-active', i != null && byState[p.getAttribute('data-state')] === i);
      p.classList.toggle('is-picked', !!state && p.getAttribute('data-state') === state);
    });
    root.querySelectorAll('[data-sdp-rep-show]').forEach(function (b) { b.classList.toggle('is-active', Number(b.getAttribute('data-sdp-rep-show')) === i); });
  }
  function show(i, state) {
    var r = reps[i];
    if (!r) return;
    highlight(i, state);
    var phoneHref = (r.phone || '').replace(/[^\d+]/g, '');
    var first = (r.contact || '').split(' ')[0];
    result.innerHTML =
      '<div class="sdp-whl__card" style="--rep: ' + esc(r.color) + ';">' +
        '<p class="sdp-whl__card-eyebrow">' + (state ? 'Your rep for ' + esc(NAMES[state] || state) : 'Rep group') + '</p>' +
        '<h3 class="sdp-whl__card-name">' + esc(r.name) + '</h3>' +
        (r.contact ? '<p class="sdp-whl__card-contact">' + esc(r.contact) + '</p>' : '') +
        '<div class="sdp-whl__card-links">' +
          (r.email ? '<a class="sdp-whl__card-btn" href="mailto:' + esc(r.email) + '?subject=' + encodeURIComponent('30 Second Dance Party wholesale') + '">Email ' + esc(first || 'them') + '</a>' : '') +
          (r.phone ? '<a class="sdp-whl__card-btn sdp-whl__card-btn--ghost" href="tel:' + esc(phoneHref) + '">' + esc(r.phone) + '</a>' : '') +
        '</div>' +
        (r.email ? '<p class="sdp-whl__card-email">' + esc(r.email) + '</p>' : '') +
        '<p class="sdp-whl__card-states">Covers ' + (r.states || []).map(function (s) { return esc(s); }).join(', ') + '</p>' +
      '</div>';
  }
  function notFound(msg) {
    highlight(null);
    result.innerHTML = '<p class="sdp-whl__hint is-error">' + esc(msg) + '</p>';
  }

  if (map) {
    map.addEventListener('click', function (e) {
      var p = e.target.closest('[data-state]');
      if (!p) return;
      var st = p.getAttribute('data-state');
      if (byState[st] == null) return notFound('We don’t have a rep in ' + (NAMES[st] || st) + ' yet. Email us and we’ll take care of you.');
      show(byState[st], st);
    });
    map.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var p = e.target.closest('[data-state]');
      if (!p) return;
      e.preventDefault();
      p.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    });
  }
  root.querySelectorAll('[data-sdp-rep-show]').forEach(function (b) {
    b.addEventListener('click', function () { show(Number(b.getAttribute('data-sdp-rep-show'))); });
  });
  root.querySelector('[data-sdp-reps-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim();
    if (!q) return input.focus();
    var st = stateFromText(q);
    if (!st) return notFound('We couldn’t find a US state in that. Try a 5-digit ZIP code, or click your state.');
    if (byState[st] == null) return notFound('We don’t have a rep in ' + (NAMES[st] || st) + ' yet. Email us and we’ll take care of you.');
    show(byState[st], st);
    if (window.matchMedia('(max-width: 749px)').matches) result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });
})();

/* Find a Retailer (sections/sdp-retailers.liquid): stores from the Wholesale
   Orders app's /api/retailers on a Leaflet map. Searching an address (or
   "Use my location") moves the map there and lists the closest stores, each
   with its Google photo and address; a store opens a card with Directions
   and View on Google. 🔥 = restocked in the last 3 months (hot); "joined" =
   first order in the last 6 months (isNew); a store can be both. Above the
   map, a slow carousel thanks the 20 latest stores. */
(function initRetailers() {
  var root = document.querySelector('[data-sdp-retailers]');
  if (!root) return;
  var endpoint = root.getAttribute('data-endpoint');
  var statusEl = root.querySelector('[data-sdp-rtl-status]');
  var listEl = root.querySelector('[data-sdp-rtl-list]');
  var cardEl = root.querySelector('[data-sdp-rtl-card]');
  var input = root.querySelector('[data-sdp-rtl-input]');
  var stores = [], byId = {}, map = null, youMarker = null, here = null;

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function miles(a, b) {
    var R = 3958.8, toR = Math.PI / 180;
    var dLat = (b.lat - a.lat) * toR, dLng = (b.lng - a.lng) * toR;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * toR) * Math.cos(b.lat * toR) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  function mi(d) { return d.toFixed(d < 10 ? 1 : 0) + ' mi'; }
  // Older API answers only have status ('hot' / 'new').
  function isHot(s) { return s.hot != null ? !!s.hot : s.status === 'hot'; }
  function isNew(s) { return s.isNew != null ? !!s.isNew : s.status === 'new'; }
  function badges(s) {
    return (isHot(s) ? '<span class="sdp-rtl__badge sdp-rtl__badge--hot" title="Restocked recently" aria-label="Restocked recently">🔥</span>' : '') +
      (isNew(s) ? '<span class="sdp-rtl__badge sdp-rtl__badge--new" title="Recently joined the family">New</span>' : '');
  }
  function where(s) { return s.address || [s.city, s.state].filter(Boolean).join(', '); }
  function photoUrl(s) { return s.photo ? endpoint + '/photo?id=' + encodeURIComponent(s.id) : ''; }
  function thumb(s, cls) {
    return '<span class="' + cls + '">' + (s.photo ? '<img src="' + esc(photoUrl(s)) + '" alt="" loading="lazy" onerror="this.remove()">' : '') +
      '<i aria-hidden="true">' + esc((s.name || '?').charAt(0)) + '</i></span>';
  }
  function links(s) {
    return '<a class="sdp-whl__card-btn" href="' + esc(s.directionsUrl) + '" target="_blank" rel="noopener">Directions</a>' +
      '<a class="sdp-whl__card-btn sdp-whl__card-btn--ghost" href="' + esc(s.mapsUrl) + '" target="_blank" rel="noopener">View on Google</a>';
  }

  function openCard(s, from) {
    var dist = from ? miles(from, s) : null;
    var photo = s.photo ? '<div class="sdp-rtl__card-photo"><img src="' + esc(photoUrl(s)) + '" alt="" loading="lazy" onerror="this.parentNode.remove()">' +
      '<span>Photo: Google' + (s.photoCredit ? ' · ' + esc(s.photoCredit) : '') + '</span></div>' : '';
    cardEl.innerHTML =
      '<button type="button" class="sdp-rtl__card-x" aria-label="Close" data-sdp-rtl-close><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
      photo +
      '<div class="sdp-rtl__card-body">' +
        '<div class="sdp-rtl__card-badges">' + badges(s) + (dist != null ? '<span class="sdp-rtl__dist">' + mi(dist) + '</span>' : '') + '</div>' +
        '<h3 class="sdp-rtl__card-name">' + esc(s.name) + '</h3>' +
        '<p class="sdp-rtl__card-addr">' + esc(where(s)) + '</p>' +
        (isHot(s) ? '<p class="sdp-rtl__card-note">Restocked recently with the newest buttons.</p>' : isNew(s) ? '<p class="sdp-rtl__card-note">Recently joined the 30 Second Dance Party family.</p>' : '') +
        '<div class="sdp-rtl__card-links">' + links(s) + '</div>' +
        ((s.website || s.phone) ? '<p class="sdp-rtl__card-more">' +
          (s.phone ? '<a href="tel:' + esc(String(s.phone).replace(/[^\d+]/g, '')) + '">' + esc(s.phone) + '</a>' : '') +
          (s.website ? '<a href="' + esc(s.website) + '" target="_blank" rel="noopener">Website</a>' : '') + '</p>' : '') +
        (!s.exact ? '<p class="sdp-rtl__card-approx">Pinned to the town; check Google for the exact spot.</p>' : '') +
      '</div>';
    cardEl.hidden = false;
    listEl.querySelectorAll('li').forEach(function (li) { li.classList.toggle('is-active', li.getAttribute('data-id') === s.id); });
  }
  cardEl.addEventListener('click', function (e) { if (e.target.closest('[data-sdp-rtl-close]')) cardEl.hidden = true; });
  function focusStore(s) {
    openCard(s, here);
    if (map) map.flyTo([s.lat, s.lng], Math.max(map.getZoom(), 13), { duration: 0.8 });
  }

  function showNearest(from, label) {
    here = from;
    var count = window.matchMedia('(max-width: 749px)').matches ? 8 : 12;
    var near = stores.map(function (s) { return { s: s, d: miles(from, s) }; }).sort(function (a, b) { return a.d - b.d; }).slice(0, count);
    statusEl.textContent = near.length ? 'Closest stores to ' + label : 'No stores found.';
    listEl.innerHTML = near.map(function (n) {
      return '<li data-id="' + esc(n.s.id) + '"><button type="button">' + thumb(n.s, 'sdp-rtl__li-photo') +
        '<span class="sdp-rtl__li-text"><span class="sdp-rtl__li-name">' + esc(n.s.name) + '</span>' +
        '<span class="sdp-rtl__li-addr">' + esc(where(n.s)) + '</span>' +
        '<span class="sdp-rtl__li-meta">' + badges(n.s) + '<span>' + mi(n.d) + '</span></span></span></button></li>';
    }).join('');
    if (map) {
      if (youMarker) youMarker.remove();
      youMarker = L.circleMarker([from.lat, from.lng], { radius: 8, color: '#fff', weight: 3, fillColor: '#4ab4e6', fillOpacity: 1 }).addTo(map).bindTooltip('You');
      var pts = [[from.lat, from.lng]].concat(near.slice(0, 5).map(function (n) { return [n.s.lat, n.s.lng]; }));
      map.flyToBounds(L.latLngBounds(pts).pad(0.25), { maxZoom: 12, duration: 1.1 });
    }
    if (near[0]) openCard(near[0].s, from);
  }
  listEl.addEventListener('click', function (e) {
    var li = e.target.closest('li[data-id]');
    var s = li && byId[li.getAttribute('data-id')];
    if (s) focusStore(s);
  });

  root.querySelector('[data-sdp-rtl-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim();
    if (!q) return input.focus();
    statusEl.textContent = 'Searching…';
    fetch(endpoint + '/geocode?q=' + encodeURIComponent(q))
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.lat == null) { statusEl.textContent = (res.j && res.j.error) || 'We couldn’t find that place.'; return; }
        showNearest({ lat: res.j.lat, lng: res.j.lng }, res.j.label || q);
      })
      .catch(function () { statusEl.textContent = 'Search isn’t available right now.'; });
  });
  root.querySelector('[data-sdp-rtl-locate]').addEventListener('click', function () {
    if (!navigator.geolocation) { statusEl.textContent = 'Your browser can’t share your location. Try searching instead.'; return; }
    statusEl.textContent = 'Finding you…';
    navigator.geolocation.getCurrentPosition(function (p) {
      showNearest({ lat: p.coords.latitude, lng: p.coords.longitude }, 'you');
    }, function () { statusEl.textContent = 'We couldn’t get your location. Try searching instead.'; }, { timeout: 10000 });
  });

  function drawMap() {
    var el = root.querySelector('[data-sdp-rtl-map]');
    map = L.map(el, { scrollWheelZoom: false, zoomControl: false, zoomSnap: 0.5 }).setView([39.5, -97.5], 4);
    L.control.zoom({ position: 'bottomright' }).addTo(map);
    // OpenStreetMap tiles, darkened in CSS (.sdp-rtl__map .leaflet-tile-pane) to match the site.
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    map.fitBounds([[24.5, -125], [49.5, -66.5]]);
    var fire = function (joined) {
      return L.divIcon({ className: 'sdp-rtl__pin-fire' + (joined ? ' is-new' : ''), html: '<span>🔥</span>', iconSize: [26, 26], iconAnchor: [13, 13] });
    };
    // Plain stores first, then joined, then restocked on top.
    var rank = function (s) { return (isHot(s) ? 2 : 0) + (isNew(s) ? 1 : 0); };
    stores.slice().sort(function (a, b) { return rank(a) - rank(b); }).forEach(function (s) {
      var m = isHot(s)
        ? L.marker([s.lat, s.lng], { icon: fire(isNew(s)), keyboard: false })
        : L.circleMarker([s.lat, s.lng], { radius: isNew(s) ? 7 : 6, color: '#211b3a', weight: 1.5, fillColor: isNew(s) ? '#f8e71c' : '#ffffff', fillOpacity: isNew(s) ? 1 : 0.85 });
      m.addTo(map).bindTooltip(esc(s.name), { direction: 'top', offset: [0, -8] });
      m.on('click', function () { openCard(s, here); });
    });
    // Scroll-zoom only once someone is using the map.
    map.on('click focus', function () { map.scrollWheelZoom.enable(); });
  }

  // Thank-you carousel: the latest stores, drifting right to left (the list is
  // doubled so it loops); hover or focus pauses it.
  function drawThanks(thanks) {
    var box = root.querySelector('[data-sdp-rtl-thanks]');
    var list = (thanks || []).map(function (t) { return byId[t.id]; }).filter(Boolean);
    if (!list.length) return;
    var card = function (s, dup) {
      return '<li' + (dup ? ' aria-hidden="true"' : '') + '><article class="sdp-rtl__tcard">' + thumb(s, 'sdp-rtl__tcard-photo') +
        '<div class="sdp-rtl__tcard-body"><div class="sdp-rtl__tcard-badges">' + badges(s) + '</div>' +
        '<h3 class="sdp-rtl__tcard-name">' + esc(s.name) + '</h3>' +
        '<p class="sdp-rtl__tcard-addr">' + esc(where(s)) + '</p>' +
        '<div class="sdp-rtl__card-links">' + (dup ? links(s).replace(/<a /g, '<a tabindex="-1" ') : links(s)) + '</div></div></article></li>';
    };
    var ul = root.querySelector('[data-sdp-rtl-thanks-list]');
    ul.innerHTML = list.map(function (s) { return card(s, false); }).join('') + list.map(function (s) { return card(s, true); }).join('');
    ul.style.setProperty('--sdp-rtl-dur', Math.max(40, list.length * 6) + 's');
    box.hidden = false;
  }

  function start(data) {
    stores = data.retailers || [];
    stores.forEach(function (s) { byId[s.id] = s; });
    var hot = stores.filter(isHot).length;
    statusEl.textContent = stores.length + ' stores carry 30 Second Dance Party' + (hot ? ' · ' + hot + ' restocked recently' : '') + '. Search to find the closest.';
    drawThanks(data.thanks);
    var go = function () { if (window.L) drawMap(); };
    if (window.L) go(); else window.addEventListener('load', go);
  }
  fetch(endpoint, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(start)
    .catch(function () { statusEl.textContent = 'The store map isn’t available right now. Please try again soon.'; });
})();

/* Store policies (layout/theme.liquid wraps them in [data-sdp-policy]): the
   bold one-line paragraphs Shopify's policy editor makes become real
   headings, and long policies get an "On this page" list. */
(function initPolicy() {
  var root = document.querySelector('[data-sdp-policy]');
  if (!root) return;
  var body = root.querySelector('.shopify-policy__body');
  var container = root.querySelector('.shopify-policy__container');
  if (!body || !container) return;
  var heads = [];
  body.querySelectorAll('p').forEach(function (p) {
    var b = p.querySelector('b, strong');
    if (!b) return;
    var rest = p.textContent.replace(b.textContent, '').trim();
    var text = b.textContent.trim();
    if (rest || !text || text.length > 90) return;
    var h = document.createElement('h2');
    h.className = 'sdp-legal__h';
    // ALL CAPS headings read better in sentence case.
    h.textContent = text === text.toUpperCase() ? text.charAt(0) + text.slice(1).toLowerCase() : text;
    p.replaceWith(h);
  });
  body.querySelectorAll('h2').forEach(function (h, i) {
    if (!h.id) h.id = 'section-' + (i + 1) + '-' + h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
    heads.push(h);
  });
  if (heads.length < 4) return;
  var toc = document.createElement('nav');
  toc.className = 'sdp-legal__toc';
  toc.setAttribute('aria-label', 'On this page');
  toc.innerHTML = '<p>On this page</p><ol>' + heads.map(function (h) {
    return '<li><a href="#' + h.id + '">' + h.textContent.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }) + '</a></li>';
  }).join('') + '</ol>';
  container.appendChild(toc);
  if ('IntersectionObserver' in window) {
    var links = toc.querySelectorAll('a');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.classList.toggle('is-current', a.getAttribute('href') === '#' + e.target.id); });
      });
    }, { rootMargin: '-120px 0px -70% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  }
})();

/* Row photo galleries (snippets/sdp-product-row.liquid, gallery): arrows,
   thumbnails and swipe step through a product's photos. Size chips: the Add
   button follows the chosen size. */
(function initGalleries() {
  document.querySelectorAll('[data-sdp-gal]').forEach(function (gal) {
    var imgs = gal.querySelectorAll('[data-sdp-gal-img]');
    var thumbs = gal.querySelectorAll('[data-sdp-gal-go]');
    var i = 0;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.hidden = k !== i; });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    gal.addEventListener('click', function (e) {
      var step = e.target.closest('[data-sdp-gal-step]');
      var go = e.target.closest('[data-sdp-gal-go]');
      if (step) show(i + Number(step.getAttribute('data-sdp-gal-step')));
      if (go) show(Number(go.getAttribute('data-sdp-gal-go')));
    });
    var x0 = null;
    var stage = gal.querySelector('.sdp-gal__stage');
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  });
})();

// Global store only: the theme's copy says "$45" and "to the continental US"
// (sections, product metafields, FAQ). Rewrite it for the visitor's country:
// the line in their currency, and no US-only wording. The US store's own
// option in the header store picker keeps its $45.
(function initRegionShipping() {
  var store = window.sdpStore || {};
  if (!store.intl || !store.freeFrom) return;
  var line = window.sdpLocalCents(store.freeFrom);
  var data = document.querySelector('[data-sdp-drawer-data]');
  var fmt = '${{amount}}';
  try { fmt = JSON.parse(data.textContent).moneyFormat || fmt; } catch (e) {}
  fmt = fmt.replace(/<[^>]*>/g, '');
  function whole(cents) {
    var n = String(Math.round(cents / 100));
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var sep = /comma_separator/.test(key) ? '.' : /apostrophe/.test(key) ? '’' : /space/.test(key) ? ' ' : ',';
      return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    });
  }
  var amount = whole(line);
  function localize(text) {
    return text
      .replace(/Under \$45, shipping is \$5\.99 to \$8\.99 depending on your order\./g, 'Under ' + amount + ', shipping is a flat rate shown at checkout.')
      .replace(/^(\s*\(?)\s*To the continental US\.?\s*(Sorry ([^.)]*)\.?)?\s*(\)?\s*)$/i, function (_, open, sorry, place, close) {
        return open + (/berlin/i.test(place || '') ? 'Worldwide. Yes, even Berlin.' : 'Worldwide.') + close;
      })
      .replace(/(?:within|to) the continental US\.?\s*Sorry Berlin\./gi, 'worldwide. Yes, even Berlin.')
      .replace(/(?:within|to) the continental US/gi, 'worldwide')
      .replace(/\$45(?![\d,]|\.\d)/g, amount);
  }
  function run(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var el = n.parentElement;
        if (!el || el.closest('script, style, textarea, .sdp-region')) return NodeFilter.FILTER_REJECT;
        return /\$45|continental US/i.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) { n.nodeValue = localize(n.nodeValue); });
    root.querySelectorAll('[aria-label*="$45"]').forEach(function (el) {
      if (!el.closest('.sdp-region')) el.setAttribute('aria-label', localize(el.getAttribute('aria-label')));
    });
    root.querySelectorAll('[data-sdp-ship-price]').forEach(function (el) {
      el.hidden = Number(el.getAttribute('data-sdp-ship-price')) < line;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document.body); });
  else run(document.body);
})();
